import { c as _c } from "react/compiler-runtime";
import { isHeading } from 'datocms-structured-text-utils';
import { renderNodeRule, StructuredText } from 'react-datocms';
import { Heading } from 'ui';
import { LinkList } from '~/components/LinkList';
export default function TravelInformationText(t0) {
  const $ = _c(3);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [renderNodeRule(isHeading, _temp)];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== data) {
    t2 = <div className="prose text-black marker:text-icons"><StructuredText data={data} customNodeRules={t1} renderBlock={_temp2} /></div>;
    $[1] = data;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp2(t0) {
  const {
    record
  } = t0;
  switch (record.__typename) {
    case "LinkListItemRecord":
      {
        return <LinkList items={[{
          url: record.url,
          title: record.title
        }]} bordered={true} />;
      }
    default:
      {
        return null;
      }
  }
}
function _temp(t0) {
  const {
    node,
    children,
    key
  } = t0;
  return <Heading as={`h${node.level}`} key={key} className="typography-title-6">{children}</Heading>;
}